/**
 * Base error class that properly extends default Error class in TypeScript
 * By extending other errors from this one, you don't need to do additional manipulations
 * (e.g. override constructor, set prototype, set name, etc.)
 */
export class BaseError extends Error {
    constructor(message, options = {}) {
        super(message, options);
        Object.setPrototypeOf(this, new.target.prototype);
        this.name = this.constructor.name;
    }
}
export class ApiTimeoutError extends BaseError {
}
//# sourceMappingURL=errors.js.map